"use strict";

var _interopRequireDefault = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _regenerator2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/regenerator.js"));
require("core-js/modules/es6.function.name");
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
var _objectSpread2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/objectSpread2.js"));
var _threePartyConfiguration = require("@/api/appBasicSetup/threePartyConfiguration");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'PushSwitch',
  props: {
    jguangBaseConfig: {
      type: Object,
      default: null
    }
  },
  data: function data() {
    return {
      switchList: [{
        key: 'androidPushStatus',
        name: '安卓推送'
      }, {
        key: 'iosPushStatus',
        name: 'iOS推送'
      }, {
        key: 'harmonyPushStatus',
        name: '鸿蒙推送'
      }],
      config: {}
    };
  },
  watch: {
    jguangBaseConfig: {
      handler: function handler(val) {
        this.config = (0, _objectSpread2.default)({}, val);
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    // 切换开关立即保存
    onChange: function () {
      var _onChange = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee(item, val) {
        var _t;
        return (0, _regenerator2.default)().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              _context.p = 0;
              _context.n = 1;
              return (0, _threePartyConfiguration.thirdConfig)({
                type: 1,
                jigangConfig: {
                  type: 0,
                  jguangBaseConfig: this.config
                }
              });
            case 1:
              this.$notify.success({
                title: '温馨提示',
                message: "".concat(item.name, "\u5DF2").concat(val === 1 ? '开启' : '关闭', "\uFF01")
              });
              _context.n = 3;
              break;
            case 2:
              _context.p = 2;
              _t = _context.v;
              // 保存失败回滚开关状态
              this.config[item.key] = val === 1 ? 0 : 1;
            case 3:
              return _context.a(2);
          }
        }, _callee, this, [[0, 2]]);
      }));
      function onChange(_x, _x2) {
        return _onChange.apply(this, arguments);
      }
      return onChange;
    }()
  }
};